/// <amd-module name="WorkItemsHub/Utils/NavigationUtils" />
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import * as VSS_Trace from "VSS/Platform/Trace";
import { IWorkItemsHubFilterDataSource } from "WorkItemsHub/Stores/IWorkItemsHubFilterDataSource";
import { UsageTelemetryHelper } from "WorkItemsHub/Utils/Telemetry";
import * as UrlUtils from "WorkItemsHub/Utils/UrlUtils";
import { TelemetryConstants } from "WorkItemsHub/Utils/Telemetry";
import { TempQueryUtils } from "Wit/Common/Utilities/TempQueryUtils";

/**
 * Type alias for open work item handler
 */
export type OnOpenWorkItemHandler = (workItemId: number, ev?: React.MouseEvent<HTMLAnchorElement>) => boolean | void;

/**
 * Opens a new tab and navigates to the Queries hub with temporary query id
 * @param pageContext Page context
 * @param projectName Project name
 * @param tabId Tab id
 * @param dataSource Work items hub filter data source
 * @param selectionIds ids of the selected items
 */
export function openInQueries(
    pageContext: IVssPageContext,
    projectName: string,
    tabId: string,
    dataSource: IWorkItemsHubFilterDataSource,
    selectionIds?: number[]
): void {
    if (dataSource) {
        const successCallback = (tempQueryId: string) => {
            win.location.href = UrlUtils.getTempQueryUrl(pageContext, projectName, tempQueryId);
        };
        const win = window.open("", "_blank");
        const hasSelection = selectionIds && selectionIds.length > 0;
        const hasFilter = dataSource.hasFilter();
        let query;
        if (hasSelection) {
            query = dataSource.generateWiqlForSelectedIds(selectionIds);
        } else if (hasFilter) {
            const filteredIds = dataSource.getFilteredIds();
            query = dataSource.generateWiqlForSelectedIds(filteredIds);
        } else {
            query = dataSource.generateWiqlForTab();
        }
        TempQueryUtils.beginCreateTemporaryQueryId(pageContext, query).then(successCallback, (error: Error) =>
            VSS_Trace.traceError(pageContext, TelemetryConstants.Area, TelemetryConstants.OpenInQueries, error.message)
        );
        UsageTelemetryHelper.publishOpenInQueriesTelemetry(pageContext, tabId, hasFilter, hasSelection);
    }
}
